import { z } from "zod";

import { buildNamespace } from "@smart/itops-types-basic";

import { system } from "./base";
import { SubmissionNS } from "./submission";
import { UserNS } from "./user";
import { TeamNS } from "./team";

export const TrackerNS = buildNamespace({
  system,
  entity: "Tracker",
} as const);

export const trackerAction = [
  "saved-to-matter",
  "matter-created",
  "submission-created",
  "submission-sent",
  "submission-closed",
  "submission-completed",
  "submission-modified",
  "submission-link-copied",
  "sent-for-signature",
  "digitally-signed-form-received",
  "intake-form-opened",
  "reminder-sent-auto",
  "reminder-sent-manual",
  "automatic-reminders-stopped",
] as const;
export type TrackerActionType = (typeof trackerAction)[number];
export const trackerActionSchema = z.enum(trackerAction);
export const TrackerSchema = z.object({
  uri: TrackerNS.schema,
  operationId: z.string(),

  submissionUri: SubmissionNS.schema,

  method: z.string().optional(),
  sentAt: z.string().optional(),

  userUri: z.union([UserNS.schema, TeamNS.schema]).optional(),
  action: trackerActionSchema.optional(),
});
